import {
	Backdrop,
	Box,
	Container,
	Divider,
	Fab,
	Fade,
	Grid,
	Modal,
	Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import PermContactCalendarIcon from "@mui/icons-material/PermContactCalendar";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import InstagramIcon from "@mui/icons-material/Instagram";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import SubscriptionsOutlinedIcon from "@mui/icons-material/SubscriptionsOutlined";
import TwitterIcon from "@mui/icons-material/Twitter";
import SmsIcon from "@mui/icons-material/Sms";
import PropagateLoader from "react-spinners/PropagateLoader";
import QRCode from "react-qr-code";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { useAPI } from "../../../../apiContext";
import PinterestIcon from "@mui/icons-material/Pinterest";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LanguageIcon from "@mui/icons-material/Language";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 4,
};

const Buttons = () => {
	const { data } = useAPI();
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const downloadTxtFile = () => {
		const element = document.createElement("a");
		const file = new Blob(
			[
				`
BEGIN:VCARD
VERSION:3.0
FN;CHARSET=UTF-8:${data?.headline?.title}
N;CHARSET=UTF-8:;${data?.headline?.title};;;
EMAIL;CHARSET=UTF-8;type=WORK,INTERNET:${data?.links?.email}
PHOTO;ENCODING=b;TYPE=X-ICON:IMAGEDATA..
TEL;TYPE=WORK,VOICE:${data?.links?.call || ""}
TITLE;CHARSET=UTF-8:${data?.headline?.subtitle} 
URL;TYPE=WEBSITE:${window.location.origin.toString()}
URL;TYPE=FACEBOOK:${data?.links?.facebook || ""}
URL;TYPE=INSTAGRAM:${data?.links?.instagram || ""}
URL;TYPE=TWITTER:${data?.links?.twitter || ""}
END:VCARD
`,
			],
			{
				type: "text/x-vcard",
			},
		);
		element.href = URL.createObjectURL(file);
		element.download = `${data?.headline?.title}.vcf`;
		document.body.appendChild(element);
		element.click();
	};

	const [show, setShow] = useState(true);
	const url = window.location.pathname;
	useEffect(() => {
		if (url.includes("/dashboard")) {
			setShow(false);
		}
	}, [url]);

	return (
		<Container sx={{ pt: 3 }}>
			<Box
				sx={{
					border: "3px solid",
					borderRadius: "15px",
					px: 1,
					pt: 1,
					pb: 1.5,
				}}
				className='borderColor'>
				{data?._id ? (
					<>
						{!data?.headline?.quickContacts === "off" ? (
							""
						) : (
							<>
								<Typography
									className='textColor'
									sx={{ mb: 0.5, fontWeight: 900 }}
									variant='h4'
									component='div'
									gutterBottom>
									{data?.headline?.quickContacts}
									<Divider className={`${data?.color?.hr}`} />
								</Typography>
								<Grid container spacing={2} className='icons'>
									{data?.links?.website !== "off" && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={() =>
													window.open(`${data?.links?.website}`, "_blank")
												}
												color='primary'
												aria-label='add'>
												<LanguageIcon />
											</Fab>
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												Website
											</Typography>
										</Grid>
									)}{" "}
									{data?.links?.email !== "off" && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={() =>
													window.open(`mailto:${data?.links?.email}`, "_blank")
												}
												color='primary'
												aria-label='add'>
												<EmailOutlinedIcon />
											</Fab>
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												Email
											</Typography>
										</Grid>
									)}
									{data?.links?.call !== "off" && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={() => window.open(`tel:${data?.links?.call}`)}
												color='primary'
												aria-label='add'>
												<LocalPhoneIcon />
											</Fab>
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												CALL
											</Typography>
										</Grid>
									)}
									{data?.links?.facebook !== "off" && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={() =>
													window.open(`${data?.links?.facebook}`, "_blank")
												}
												color='primary'
												aria-label='add'>
												<FacebookOutlinedIcon />
											</Fab>{" "}
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												Facebook
											</Typography>
										</Grid>
									)}
									{data?.links?.whatsapp !== "off" && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={() =>
													window.open(
														`https://api.whatsapp.com/send?phone=${data?.links?.whatsapp}`,
														"_blank",
													)
												}
												color='primary'
												aria-label='add'>
												<WhatsAppIcon />
											</Fab>
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												Whatsapp
											</Typography>
										</Grid>
									)}
									{data?.links?.instagram !== "off" && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={() =>
													window.open(`${data?.links?.instagram}`, "_blank")
												}
												color='primary'
												aria-label='add'>
												<InstagramIcon />
											</Fab>
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												Instagram
											</Typography>
										</Grid>
									)}
									{data?.links?.sms !== "off" && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={() =>
													window.open(`sms:${data?.links?.sms}`, "_blank")
												}
												color='primary'
												aria-label='add'>
												<SmsIcon />
											</Fab>
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												TEXT
											</Typography>
										</Grid>
									)}
									{data?.links?.twitter !== "off" && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={() =>
													window.open(`${data?.links?.twitter}`, "_blank")
												}
												color='primary'
												aria-label='add'>
												<TwitterIcon />
											</Fab>{" "}
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												Twitter
											</Typography>
										</Grid>
									)}
									{data?.links?.youtube !== "off" && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={() =>
													window.open(`${data?.links?.youtube}`, "_blank")
												}
												color='primary'
												aria-label='add'>
												<SubscriptionsOutlinedIcon />
											</Fab>
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												Youtube
											</Typography>
										</Grid>
									)}
									{data?.links?.linkedin !== "off" && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={() =>
													window.open(`${data?.links?.linkedin}`, "_blank")
												}
												color='primary'
												aria-label='add'>
												<LinkedInIcon />
											</Fab>
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												LinkedIn
											</Typography>
										</Grid>
									)}
									{data?.links?.pinterest !== "off" && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={() =>
													window.open(`${data?.links?.pinterest}`, "_blank")
												}
												color='primary'
												aria-label='add'>
												<PinterestIcon />
											</Fab>
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												Pinterest
											</Typography>
										</Grid>
									)}
									{show && (
										<Grid
											item
											xs
											sx={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
											}}>
											<Fab
												onClick={handleOpen}
												color='primary'
												aria-label='add'>
												<QrCode2Icon />
											</Fab>
											<Typography
												sx={{ mt: 1, fontWeight: "bold" }}
												variant='button'
												className='textColor'
												display='block'>
												QR
											</Typography>
										</Grid>
									)}
									{data?.links?.vcf !== "off" && (
										<>
											{show && (
												<Grid className='contactList' item md={12} xs={12}>
													<Fab
														onClick={downloadTxtFile}
														variant='extended'
														sx={{
															px: 4,
															fontWeight: "bold",
														}}>
														<PermContactCalendarIcon sx={{ mr: 1.5 }} />
														Add to contact list
													</Fab>
												</Grid>
											)}
										</>
									)}
								</Grid>
								<Modal
									aria-labelledby='transition-modal-title'
									aria-describedby='transition-modal-description'
									open={open}
									onClose={handleClose}
									closeAfterTransition
									BackdropComponent={Backdrop}
									BackdropProps={{
										timeout: 500,
									}}>
									<Fade in={open}>
										<Box sx={style}>
											<Typography
												sx={{ mb: 2, textAlign: "center", fontWeight: "bold" }}
												className='textColor'
												id='transition-modal-title'
												variant='h5'>
												Scan Me
											</Typography>
											<QRCode
												fgColor={`${data?.color?.color1st}`}
												value={`${window.location.origin.toString()}`}
											/>
										</Box>
									</Fade>
								</Modal>
							</>
						)}
					</>
				) : (
					<div className='loader'>
						<PropagateLoader size={11} />
					</div>
				)}
			</Box>
		</Container>
	);
};

export default Buttons;
